export default __webpack_public_path__ + "static/media/utility9.9e9eefd4.svg";